// extracted by mini-css-extract-plugin
module.exports = {"main":"button-panel_main__2IgJb","btns":"button-panel_btns__259-_"};